module.exports = __webpack_public_path__ + "static/media/truck.d410244f.svg";